import React, { useCallback, useContext } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { getAccessIconsFromArray } from '../../apps/Dashboard/helpers/getAccessIcon';
import BrowserLink from '../BrowserLink';
import { getMediaUrl } from '../../utils/utils';
import { useDateSolver } from '../../hooks/useDateSolver';
import LiveIcon from '../../icons/live.svg';
import './LiveEventCard.scss';
import classnames from 'classnames';
import { AppContext } from '../../AppContext';

export function LiveEventCard({ item }) {
  const {
    id,
    images,
    air_date,
    start_date,
    start_date_timestamp,
    end_date_timestamp,
    description,
    type,
    date,
    img,
    title,
    time,
    access,
    link,
    desc,
    imgAlt,
  } = item;
  let imageSrc, href;

  const { user } = useContext(AppContext);

  const { dateToShow, isLive } = useDateSolver({
    air_date,
    type,
    end_date_timestamp,
    date,
    desc,
    time,
    start_date_timestamp,
    start_date
  });

  if (type === 'webinars') {
    imageSrc = img;
    href = link;
  }
  if (type === 'video') {
    // dateToShow = `${format(new Date(air_date), 'MMM d')} at
    // ${format(new Date(air_date), "h:mm aaaaa'm")}`;
    const sdImage = images.find(image => image.label === 'SD');
    imageSrc = sdImage ? sdImage.url : images[0].url;
    href = `https://www.pokergo.com/videos/${id}`;
  }

  const handleRegisterClick = useCallback(
    (e) => {
      window.analytics?.track('button:click', {
        button_name: 'Register',
        parent_object_title: 'Live events',
        title: title,
      });

      window.showPopupPlan({
        title: 'Start your PokerCoaching membership today to unlock this class!',
        planSet: access.includes('pc') ? 'standard-premium' : 'premium',
        activePremium: access.includes('pc'),
        redirectionObjectTitle: title,
        userAccess: user.type,
      });
      e.preventDefault();
    },
    [access, title, user]
  );

  const WrapperComponent = ({ children, className }) => {
    if (type === 'webinars' && !href?.length) {
      return (
        <div
          onClick={handleRegisterClick}
          className={className}
          children={children}
        />
      );
    }

    if (href) {
      return (
        <BrowserLink
          href={href}
          target="_blank"
          rel="noreferrer"
          children={children}
          className={className}
        />
      );
    }
    return children;
  };

  return (
    <div className="LiveEventCard">
      <WrapperComponent className="LiveEventCard__wrapper-component">
        <div className="LiveEventCard__wrapper">
          <div className="LiveEventCard__inner">
            <div className="LiveEventCard__inner-image-block">
              <LazyLoadImage
                className="LiveEventCard__inner-image-element"
                src={imageSrc}
                alt={imgAlt || description}
              />
              {isLive && (
                <div className="LiveEventCard__inner-live-icon">
                  <img
                    className="LiveEventCard__inner-live-icon-svg"
                    src={getMediaUrl(LiveIcon)}
                    alt=""
                  />
                </div>
              )}
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: description }}
              className="LiveEventCard__inner-description"
            />
          </div>
          <div
            className={classnames('LiveEventCard__block', {
              '_video-event': type === 'video',
            })}
          >
            <div className="LiveEventCard__block-access">
              {access && getAccessIconsFromArray(access)}
            </div>
            <div className="LiveEventCard__block-date">{dateToShow}</div>
          </div>
        </div>
      </WrapperComponent>
    </div>
  );
}
